import React from "react";
import IndividualMilestone from "./individualMilestone";
import { Action } from "../../../constants/Common";

const AddMilestoneModule = (props) => {
  return (
    <div
      className="editDeliverable_height"
      style={{ height: "auto", maxHeight: "1200px" }}
    >
      {props?.milestones &&
        props?.milestones?.map((mL, index) => {
          return (
            <IndividualMilestone
              key={index}
              action={Action.CREATE}
              eachMilestone={mL}
              eachMilestoneIndex={index}
            />
          );
        })}
    </div>
  );
};

export default AddMilestoneModule;
